/* eslint-disable */
import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {
  TaskStatistics,
  TaskStatisticsService
} from '../../../../lib/statistics/task-statistics/task-statistics.service';
import {MultiselectOptionItem, QueryFieldModel, UiConstants} from '../../../../util/core-utils';
import {OrderType} from '../../../../lib/util/services';
import {BreadcrumbParent} from '../../../../shared/breadcrumb/breadcrumb/breadcrumb.component';
import {
  TaskStatisticsSearch,
  TaskStatisticsSearchService
} from '../../../../lib/statistics/task-statistics/task-statistics-search.service';
import {combineLatest, Observable} from 'rxjs';
import {StateName} from '../../../../app.state-names';
import {TranslateService} from '@ngx-translate/core';
import {Icon} from '../../../../lib/task/icon.service';
import {List, Set} from 'immutable';
import {Logger, LoggerFactory} from '../../../../util/logger-factory';
import {NgbDateStruct, NgbTimeStruct} from "@ng-bootstrap/ng-bootstrap";
import {UserMultiselectProvider} from "../../../../lib/user/user-multiselect.provider";
import {TaskMultiselectOptionItem, TaskMultiselectProvider} from "../../../../lib/task/task-multiselect.provider";
import {Angular2Multiselects} from "../../../../util/multiselect";
import {OffsetDateTime} from "../../../../lib/util/dates";
import {NgbDatePickerParserFormatter} from "../../../../util/ngb-datepicker";
import {Models} from "../../../../util/model-utils";
import {DownloadedFile} from "../../../../lib/util/downloaded-files";
import { saveAs } from 'file-saver';

/* eslint-enable */

@Component({
  selector: 'app-task-statistics-list',
  templateUrl: './task-statistics-list.component.html',
  styleUrls: ['./task-statistics-list.component.scss']
})
export class TaskStatisticsListComponent implements OnInit, AfterViewInit, OnDestroy {
  TaskStatistics = TaskStatistics;
  UiConstants = UiConstants;

  queryModel: QueryFieldModel<TaskStatistics.OrderField> = new QueryFieldModel(TaskStatistics.OrderField.TASK_NAME, OrderType.ASC);
  taskStatistics: StatModel[] = [];
  usersForSearch: MultiselectOptionItem<number>[] = [];
  tasksForSearch: TaskMultiselectOptionItem[] = [];
  usersForList: MultiselectOptionItem<number>[] = [];
  tasksForList: TaskMultiselectOptionItem[] = [];
  searchModel: TaskStatisticsSearchModel = new TaskStatisticsSearchModel();
  showSearch: boolean = false;
  breadcrumbParents: BreadcrumbParent[] = [];
  breadcrumbSelf: string;
  compactSidebar: boolean = document.querySelector('body')!.classList.contains('sidebar-compact');
  dropdownSettingsForMultiWithRemoteSearch: Angular2Multiselects.Settings;
  private logger: Logger;

  constructor(
    private taskStatisticsService: TaskStatisticsService,
    private taskStatisticsSearchService: TaskStatisticsSearchService,
    private translateService: TranslateService,
    private ngbDatePickerParserFormatter: NgbDatePickerParserFormatter,
    private userMultiselectProvider: UserMultiselectProvider,
    private taskMultiselectProvider: TaskMultiselectProvider) {
    this.logger = LoggerFactory.createLogger('TaskStatisticsListComponent');
  }

  ngOnInit() {
    this.dropdownSettingsForMultiWithRemoteSearch = new Angular2Multiselects.SettingsBuilder()
      .singleSelection(false)
      .enableSearchFilter(true)
      .enableCheckAll(true)
      .remoteSearch(true)
      .build();

    this.translateService.get('MENU_NAVBAR_TASK_STATISTICS').subscribe(
      (result: string) => {
        this.breadcrumbSelf = result;
      }
    );
    this.translateService.get('MENU_NAVBAR_MENU_ADMINISTRATION').subscribe(
      (result: string) => {
        this.breadcrumbParents.push({name: result, uiSref: StateName.ADMIN_DASHBOARD});
      }
    );
    this.loadSearch(() => {
      this.showSearch = !this.searchModel.isEmpty();
      this.loadList();
    });
  }

  ngAfterViewInit() {
    this.loadList();
  }

  private loadSearch(completion: () => void) {
    const obs: Observable<SearchLoadResult> = combineLatest(
      this.taskStatisticsSearchService.getSearchData({}),
      (storedSearchData: TaskStatisticsSearch.SearchDataResult) => {
        const result: SearchLoadResult = {
          storedSearchData: storedSearchData
        };
        return result;
      }
    );
    obs.subscribe(
      (result: SearchLoadResult) => {
        this.postInitSearch(result.storedSearchData);
        completion();
      }
    );
  }

  onUserSearch(q?: string) {
    this.userMultiselectProvider.loadActive(q).subscribe(u => {
      this.usersForSearch = u;
    });
  }

  onTaskSearch(q?: string) {
    this.taskMultiselectProvider.loadActive(q).subscribe(t => {
      this.tasksForSearch = t;
    });
  }

  private postInitSearch(storedSearchData: TaskStatisticsSearch.SearchDataResult) {
    this.queryModel.itemsPerPage = storedSearchData.searchData.itemsPerPage;
    this.queryModel.currentPage = storedSearchData.searchData.pageNumber;
    this.queryModel.setOrder(storedSearchData.searchData.order);
    this.searchModel.task = storedSearchData.searchData.task;
    this.searchModel.user = storedSearchData.searchData.user;
    this.searchModel.fromDate = storedSearchData.searchData.fromDate;
    this.searchModel.toDate = storedSearchData.searchData.toDate;
    this.searchModel.fromTime = storedSearchData.searchData.fromTime;
    this.searchModel.toTime = storedSearchData.searchData.toTime;
  }

  private loadList(pageNumber?: number) {
    const requestedPage = pageNumber ? pageNumber : this.queryModel.currentPage;
    this.taskStatisticsService.query(this.getQueryRequest(requestedPage))
      .subscribe(
        (taskStatistics: List<TaskStatistics.TaskStatistic>) => {
          this.taskStatistics = taskStatistics.toArray().map(s => {
            const a = new StatModel();
            a.statistics = s;
            return a;
          });
          this.loadUsersForList();
          this.loadTasksForList();
          this.queryModel.currentPage = requestedPage;
          this.queryModel.indeterminateNumberOfItems(requestedPage);
        }
      );
  }

  onSearchClicked() {
    this.loadList();
  }

  onSearchReset() {
    this.taskStatisticsSearchService.resetSearchData({}).subscribe(
      (result) => {
        this.loadSearch(() => {
          this.showSearch = true;
          this.loadList(1);
        });
      }
    );
  }

  private saveSearch() {
    const request = {
      searchData: {
        itemsPerPage: this.queryModel.itemsPerPage,
        pageNumber: this.queryModel.currentPage,
        order: this.queryModel.getOrder(),
        task: this.searchModel.task,
        user: this.searchModel.user,
        fromDate: this.searchModel.fromDate,
        toDate: this.searchModel.toDate,
        fromTime: this.searchModel.fromTime,
        toTime: this.searchModel.toTime,
      }
    };
    this.taskStatisticsSearchService.setSearchData(request).subscribe(
      (result) => {
        this.logger.debug('Search model has saved');
      },
      (error) => {
        this.logger.warn('Failed to save the search model');
      }
    );
  }

  pageChanged(selectedPage: number) {
    this.loadList(selectedPage);
  }

  itemsPerPageChanged(itemsPerPage: number) {
    this.queryModel.itemsPerPage = itemsPerPage;
    this.loadList(1);
  }

  orderBy(field: TaskStatistics.OrderField) {
    this.queryModel.onOrderFieldChanged(field);
    this.loadList(1);
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
  }

  exportXlsx() {
    this.taskStatisticsService.exportXlsx(
      this.getQueryRequest(1)
    ).subscribe((res: DownloadedFile) => {
      saveAs(res.getBlob(), res.getFileName('task-log-stats.xlsx'));
    });
  }


  private loadUsersForList() {
    const notFound: number[] = [];
    this.taskStatistics.forEach(s => {
      if (!s.userData) {
        const data = this.usersForList.find(u => u.id === s.statistics.userId);
        if (data) {
          s.userData = data;
        } else {
          notFound.push(s.statistics.userId);
        }
      }
    })
    if (notFound.length === 0) {
      return;
    }
    this.userMultiselectProvider.getByIds(notFound).subscribe(u => {
      this.usersForList.push(...u);
      this.loadUsersForList();
    });
  }

  private loadTasksForList() {
    const notFound: number[] = [];
    this.taskStatistics.forEach(s => {
      if (!s.taskData) {
        const data = this.tasksForList.find(u => u.id === s.statistics.taskId);
        if (data) {
          s.taskData = data;
        } else {
          notFound.push(s.statistics.taskId);
        }
      }
    })
    if (notFound.length === 0) {
      return;
    }
    this.taskMultiselectProvider.getByIds(notFound).subscribe(u => {
      this.tasksForList.push(...u);
      this.loadTasksForList();
    });
  }

  private getUserName(data: MultiselectOptionItem<number> | undefined): string {
    if (!data) {
      return '';
    }
    return data.itemName;
  }


  private getTaskName(data: TaskMultiselectOptionItem | undefined): string {
    if (!data) {
      return '';
    }
    return data.itemName;
  }

  private getTaskIcon(data: TaskMultiselectOptionItem | undefined): Icon.Icon | undefined {
    if (!data) {
      return undefined;
    }
    return data.icon;
  }

  getColorIndex(data: TaskMultiselectOptionItem | undefined): number {
    if (!data) {
      return 0;
    }
    return data.taskRecordColor;
  }


  ngOnDestroy() {
    this.saveSearch();
  }

  private getFromDate() {
    if ((!this.searchModel.fromDate && !this.searchModel.fromTime)
      || this.searchModel.fromTime) {
      return this.ngbDatePickerParserFormatter
        .toOffsetDateTime(this.searchModel.fromDate, this.searchModel.fromTime);
    }
    return Models.parseDateTimeFrom(this.searchModel.fromDate).startOfDay();
  }
  private getToDate() {
    if ((!this.searchModel.toDate && !this.searchModel.toTime)
      || this.searchModel.toTime) {
      return this.ngbDatePickerParserFormatter
        .toOffsetDateTime(this.searchModel.toDate, this.searchModel.toTime);
    }
    return Models.parseDateTimeFrom(this.searchModel.toDate).endOfDay();
  }

  private getQueryRequest(requestedPage: number) {
    const order = this.queryModel.getOrder();
    let fromDate: OffsetDateTime = this.getFromDate();
    let toDate: OffsetDateTime = this.getToDate();
    return {
      fromDate: fromDate,
        toDate: toDate,
      taskId: this.searchModel.task.length > 0 ? Set.of(...this.searchModel.task.map(t => t.id)) : undefined,
      userId: this.searchModel.user.length > 0 ? Set.of(...this.searchModel.user.map(u => u.id)) : undefined,
      paging: {
      pageNumber: requestedPage,
        numberOfItems: this.queryModel.itemsPerPage
    },
      order: Set.of(order)
    }
  }
}

class TaskStatisticsSearchModel {
  task: TaskMultiselectOptionItem[] = [];
  user: MultiselectOptionItem<number>[] = [];
  fromDate: NgbDateStruct | null = null;
  toDate: NgbDateStruct | null = null;
  fromTime: NgbTimeStruct | null = null;
  toTime: NgbTimeStruct | null = null;


  public isEmpty(): boolean {
    return this.task.length === 0
      && this.user.length === 0
      && this.fromDate === null
      && this.fromTime === null
      && this.toDate === null
      && this.toTime === null
      ;
  }
}

interface SearchLoadResult {
  storedSearchData: TaskStatisticsSearch.SearchDataResult,
}

class StatModel {
  statistics: TaskStatistics.TaskStatistic;
  taskData?: TaskMultiselectOptionItem;
  userData?: MultiselectOptionItem<number>;
}
